import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/Layout';
import GoogleAnalytics from './components/GoogleAnalytics';
import Dashboard from './pages/Dashboard';
import Sequences from './pages/Sequences';
import BiasResults from './pages/BiasResults';
import ApiResults from './pages/ApiResults';
import Alerts from './pages/Alerts';
import Settings from './pages/Settings';
import EvaluationTypes from './pages/EvaluationTypes';
import AuditLog from './pages/AuditLog';
import Login from './pages/Login';
import Demo from './pages/Demo';
import AcceptInvite from './pages/AcceptInvite';
import ContactSales from './pages/ContactSales';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <Box>Loading...</Box>;
  }
  
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <GoogleAnalytics />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/accept-invite/:token" element={<AcceptInvite />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/sequences" element={<Sequences />} />
                  <Route path="/results" element={<BiasResults />} />
                  <Route path="/bias-results" element={<BiasResults />} />
                  <Route path="/api-results" element={<ApiResults />} />
                  <Route path="/evaluation-types" element={<EvaluationTypes />} />
                  <Route path="/alerts" element={<Alerts />} />
                  <Route path="/audit-log" element={<AuditLog />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/contact-sales" element={<ContactSales />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
};

export default App;
